import { render, staticRenderFns } from "./Itens_Pedido.vue?vue&type=template&id=007a2810&scoped=true"
import script from "./Itens_Pedido.vue?vue&type=script&lang=js"
export * from "./Itens_Pedido.vue?vue&type=script&lang=js"
import style0 from "./Itens_Pedido.vue?vue&type=style&index=0&id=007a2810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a2810",
  null
  
)

export default component.exports